(function(){
  var root = document.querySelector('.sp[data-sp]');
  var D = JSON.parse(document.getElementById('spData').textContent);
  if (!D.variants.length) return;
  function $(id){ return document.getElementById(id); }
  function money(c){ return '$' + (c/100).toFixed(2); }
  var TIERS = [
    { q:1, name:'Solo Recruit', cap:'One costume', off:0 },
    { q:2, name:'Buddy Pair', cap:'2 costumes · save 12%', off:12, badge:'MOST POPULAR', benefit:'FREE US SHIPPING' },
    { q:3, name:'Full Platoon', cap:'3 costumes · save 20%', off:20, badge:'BEST VALUE', benefit:'FREE US SHIPPING' }
  ];
  var V = D.variants, OPT_OUT = 'sp_prot_off';
  function ss(k,v){ try{ if(v===undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k,v); }catch(e){ return null; } }

  /* Gallery */
  var cur = 0, pic = $('spMainPic'), thumbs = $('spThumbs'), dots = $('spDots');
  D.images.forEach(function(im,i){
    var b = document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Image '+(i+1));
    b.innerHTML = '<img loading="lazy" src="'+im.thumb+'" alt="">'; b.onclick = function(){ show(i); };
    thumbs.appendChild(b); dots.appendChild(document.createElement('span'));
  });
  function show(i){
    if (!D.images.length) return;
    cur = (i + D.images.length) % D.images.length;
    pic.src = D.images[cur].src; pic.alt = D.images[cur].alt || '';
    [].forEach.call(thumbs.children,function(t,k){ t.classList.toggle('on',k===cur); });
    [].forEach.call(dots.children,function(d,k){ d.classList.toggle('on',k===cur); });
  }
  root.querySelector('.g-arrow.prev').onclick = function(){ show(cur-1); };
  root.querySelector('.g-arrow.next').onclick = function(){ show(cur+1); };
  var sx = null, mi = $('spMainImg');
  mi.addEventListener('touchstart',function(e){ sx = e.touches[0].clientX; },{passive:true});
  mi.addEventListener('touchend',function(e){ if(sx===null) return; var dx = e.changedTouches[0].clientX - sx; if(Math.abs(dx)>40) show(cur+(dx<0?1:-1)); sx=null; });
  show(0);

  /* Size pills */
  var vi = Math.max(0, V.findIndex(function(v){ return v.available; }));
  V.forEach(function(v,i){
    var p = document.createElement('button'); p.type='button'; p.className='pill'; p.textContent=v.title; p.disabled = !v.available;
    p.onclick = function(){ vi = i; renderPills(); syncPer(); };
    $('spPills').appendChild(p);
  });
  function renderPills(){
    $('spSizeLabel').textContent = V[vi].title;
    [].forEach.call($('spPills').children,function(p,i){ p.classList.toggle('on',i===vi); });
  }

  /* Tiers */
  var sel = 1, per = {};
  var opts = V.map(function(v,i){ return '<option value="'+i+'"'+(v.available?'':' disabled')+'>'+v.title+'</option>'; }).join('');
  function tierTotal(t){ return Math.round(V[vi].price * t.q * (1 - t.off/100)); }
  TIERS.forEach(function(t,i){
    var el = document.createElement('div'); el.className='tier'; el.tabIndex=0;
    var sp = '';
    if (t.q>1){ sp='<div class="sizes-per">'; for(var k=0;k<t.q;k++) sp+='<label>#'+(k+1)+' <select data-t="'+i+'" data-k="'+k+'">'+opts+'</select></label>'; sp+='</div>'; }
    el.innerHTML = (t.badge?'<span class="t-badge">'+t.badge+'</span>':'')+'<span class="radio"></span><img src="'+(D.tierImgs[i]||'')+'" alt="">'+
      '<div><div class="t-name">'+t.name+'</div><div class="t-cap">'+t.cap+'</div>'+(t.benefit?'<span class="t-benefit">'+t.benefit+'</span>':'')+'</div>'+
      '<div class="t-price"><b data-total></b><s data-compare></s></div>'+sp;
    el.onclick = function(e){ if (/SELECT|OPTION/.test(e.target.tagName)) return; sel=i; renderTiers(); };
    el.onkeydown = function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); sel=i; renderTiers(); } };
    $('spTiers').appendChild(el);
  });
  root.addEventListener('change',function(e){ if (e.target.matches('.sizes-per select')) per[e.target.dataset.t+'-'+e.target.dataset.k] = +e.target.value; });
  function syncPer(){ root.querySelectorAll('.sizes-per select').forEach(function(s){ s.value = vi; per[s.dataset.t+'-'+s.dataset.k] = vi; }); renderTiers(); }
  function renderTiers(){
    [].forEach.call($('spTiers').children,function(el,i){
      var t = TIERS[i]; el.classList.toggle('on',i===sel);
      el.querySelector('[data-total]').textContent = money(tierTotal(t));
      el.querySelector('[data-compare]').textContent = money(V[vi].compare * t.q);
    });
    var t = TIERS[sel], tot = tierTotal(t), each = tot / t.q;
    ['spAtcPrice','spSPrice','spSBtnPrice'].forEach(function(id){ $(id).textContent = money(tot); });
    $('spNow').textContent = money(each); $('spWas').textContent = money(V[vi].compare);
    var pct = Math.round((1 - each / V[vi].compare) * 100);
    $('spBadge').textContent = 'SAVE ' + pct + '%'; $('spBadge').hidden = pct <= 0;
  }
  renderPills(); syncPer();

  /* Delivery dates */
  function fmt(d){ return d.toLocaleDateString('en-US',{month:'short',day:'numeric'}); }
  function biz(n){ var d=new Date(),c=0; while(c<n){ d.setDate(d.getDate()+1); if(d.getDay()%6) c++; } return d; }
  $('spD1').textContent = fmt(new Date()); $('spD2').textContent = fmt(biz(1))+' - '+fmt(biz(2)); $('spD3').textContent = fmt(biz(7))+' - '+fmt(biz(10));

  /* Cart */
  function post(url, body){ return fetch(url + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) }).then(function(r){ if(!r.ok) return r.json().then(function(j){ throw j; }); return r.json(); }); }
  function getCart(){ return fetch(D.routes.cart + '.js', { headers:{Accept:'application/json'} }).then(function(r){ return r.json(); }); }

  function addToCart(){
    var btns = [$('spAtc'), $('spStickyBtn')]; btns.forEach(function(b){ b.setAttribute('aria-busy','true'); });
    var t = TIERS[sel], counts = {};
    for (var k=0;k<t.q;k++){ var idx = t.q===1 ? vi : (per[sel+'-'+k] != null ? per[sel+'-'+k] : vi); counts[V[idx].id] = (counts[V[idx].id]||0) + 1; }
    var items = Object.keys(counts).map(function(id){ return { id:+id, quantity:counts[id] }; });
    getCart().then(function(c){
      var hasProt = c.items.some(function(i){ return i.variant_id === D.protectId; });
      if (D.protectId && !hasProt && ss(OPT_OUT) !== '1') items.push({ id: D.protectId, quantity: 1 });
      return post(D.routes.add, { items: items });
    }).then(function(){ return refresh(true); })
      .catch(function(err){ alert((err && (err.description || err.message)) || 'Could not add to cart. Please try again.'); })
      .finally(function(){ btns.forEach(function(b){ b.removeAttribute('aria-busy'); }); });
  }

  function lineHTML(it, isProt){
    if (isProt) return '<div class="line"><div class="prot-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg></div>'+
      '<div><div class="ln">Shipping Protection</div><div class="lv">Covers loss, theft &amp; damage in transit</div><button type="button" class="rm" data-key="'+it.key+'" data-prot="1">Remove</button></div><div class="lp">'+money(it.final_line_price)+'</div></div>';
    var compare = (it.original_line_price !== it.final_line_price) ? '<s>'+money(it.original_line_price)+'</s>' : '';
    return '<div class="line"><img src="'+(it.image ? it.image + (it.image.indexOf('?')>-1?'&':'?') + 'width=140' : '')+'" alt=""><div><div class="ln">'+it.product_title+'</div><div class="lv">'+(it.variant_title ? 'Size: '+it.variant_title : '')+'</div>'+
      '<div class="qty"><button type="button" data-key="'+it.key+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease">−</button><span>'+it.quantity+'</span><button type="button" data-key="'+it.key+'" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div></div>'+
      '<div class="lp">'+money(it.final_line_price)+compare+'</div></div>';
  }

  function refresh(open){
    return getCart().then(function(c){
      var prot = null, others = 0;
      c.items.forEach(function(i){ if (i.variant_id === D.protectId) prot = i; else others += i.quantity; });
      /* Keep protection sane: drop it with an empty cart, cap at 1 */
      if (prot && (others === 0 || prot.quantity > 1)) {
        return post(D.routes.change, { id: prot.key, quantity: others === 0 ? 0 : 1 }).then(function(){ return refresh(open); });
      }
      var body = $('spBody'), foot = $('spFoot'), timer = $('spTimer');
      if (!c.item_count) {
        body.innerHTML = '<div class="empty"><p>Your cart is empty.</p><a class="btn" href="#sp-product" data-close>Shop the costume</a></div>';
        foot.style.display = 'none'; timer.style.display = 'none';
      } else {
        foot.style.display = ''; timer.style.display = '';
        var html = '';
        c.items.forEach(function(i){ if (i.variant_id !== D.protectId) html += lineHTML(i,false); });
        if (prot) html += lineHTML(prot,true);
        body.innerHTML = html;
        var compareTotal = 0;
        c.items.forEach(function(i){ if (i.variant_id !== D.protectId) { var v = V.find(function(x){ return x.id === i.variant_id; }); compareTotal += (v ? v.compare : i.price) * i.quantity; } });
        var goods = c.total_price - (prot ? prot.final_line_price : 0);
        $('spSave').textContent = '-' + money(Math.max(0, compareTotal - goods));
        $('spSub').textContent = money(c.total_price);
      }
      $('spCartHead').textContent = 'Cart • ' + c.item_count + (c.item_count === 1 ? ' item' : ' items');
      document.querySelectorAll('.cart-count-bubble span, [data-cart-count], cart-count, .header__icon--cart .cart-count').forEach(function(el){ el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource:c, source:'sp-landing' } }));
      if (open) openCart();
    });
  }
  $('spBody').addEventListener('click',function(e){
    var b = e.target.closest('button[data-key]');
    if (b) {
      if (b.dataset.prot) ss(OPT_OUT,'1');
      post(D.routes.change, { id: b.dataset.key, quantity: b.dataset.prot ? 0 : Math.max(0, +b.dataset.q) }).then(function(){ refresh(false); });
    }
    if (e.target.closest('[data-close]')) closeCart();
  });
  function openCart(){ $('spDrawer').classList.add('show'); $('spOverlay').classList.add('show'); startTimer(); }
  function closeCart(){ $('spDrawer').classList.remove('show'); $('spOverlay').classList.remove('show'); }
  $('spClose').onclick = closeCart; $('spOverlay').onclick = closeCart;
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeCart(); });
  $('spAtc').onclick = addToCart; $('spStickyBtn').onclick = addToCart;
  $('spCheckout').onclick = function(){ window.location.href = D.routes.checkout; };

  var tLeft = 300, tInt = null;
  function startTimer(){
    if (tInt) return;
    tInt = setInterval(function(){
      tLeft = Math.max(0, tLeft-1);
      $('spTimer').textContent = 'Cart reserved for ' + Math.floor(tLeft/60) + ':' + String(tLeft%60).padStart(2,'0');
      if (!tLeft){ clearInterval(tInt); tInt=null; tLeft=300; }
    },1000);
  }
  /* Header cart icon opens this drawer on this page */
  document.addEventListener('click',function(e){
    var a = e.target.closest('a[href$="/cart"], [href="/cart"], .header__icon--cart, cart-drawer-component button, [data-testid="cart-drawer-trigger"]');
    if (a && !root.contains(a)) { e.preventDefault(); e.stopPropagation(); refresh(true); }
  }, true);

  var sticky = $('spSticky');
  new IntersectionObserver(function(es){ es.forEach(function(e){ sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe($('spAtc'));
})();